export default "__VITE_ASSET__BkABxtXn__"